export default function allRolePermissions(el, entity) {
  el.addEventListener("change", function(e) {
    var inputs = document.querySelectorAll(
      "tr[data-permission-fields=" + entity + "] input[type=checkbox]"
    );

    inputs.forEach(function(i) {
      i.checked = e.target.checked;
    });

    return true;
  });
}
